// extracted by mini-css-extract-plugin
module.exports = {"halfTextImagehalfForm":"HalfTextImageHalfFullForm_halfTextImagehalfForm__DN_Pd"};